import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { GatewayListItem } from '../../site-gateway/models/gateway';
import { SetupId } from '../models/Site';

export interface SetupGateway {
    fetchGateways(setupId: SetupId): Observable<GatewayListItem[]>;
}

export const SETUP_GATEWAY = new InjectionToken<SetupGateway>('SETUP_GATEWAY');
